.section {
    display: flex;
    flex-direction: column;
    gap: 8px;
}

.fields-grid {
    display: grid;
    grid-template-columns: 1fr 1fr;
    gap: 12px;
}

.settings-content {
    padding: 32px;
    margin: 0 -32px;
}
